const MOTIVATIONAL_MESSAGE_PATH = 'configuration/motivationalMessage/';
const SESSION_PATH = '/session/';
const ABOUT_US = '/configuration/about_us/';
const ABOUT_FAQS = (queryParams) =>`/configuration/help/${queryParams}`;
const FAQS_TOPICS = '/configuration/help/topics/';
const ABOUT_COMMENT = '/configuration/feedback/';
const SETTINGS_TIMEZONES = '/timezone/';
const SETTINGS_NOTIFICATION_SETUP = (isParent, userId) =>
  `/${isParent ? 'parent' : 'child'}/${userId}/get_notification_setup/`;
const SETTINGS_GET_TIMEZONE_SETUP = (isParent, userId) =>
  `/${isParent ? 'parent' : 'child'}/${userId}/timezone_setup/`;
const SETTINGS_UPDATE_CONFIGURATION = (isParent, userId) =>
  `/${isParent ? 'parent' : 'child'}/${userId}/configure_notifications/`;
const GET_TIPS = '/tips/';
const GET_PARENT_BY_EMAIL = (email) => `/parent/filter_by_params/?email=${email}`;
const PARENT_ASSIGN_CHILDREN = (parentId) => `/parent/${parentId}/assign_children/`;
const INVITE_PARENT = (parentId) => `/parent/${parentId}/invite_parent/`;
const CHANGE_PARENT_THEME = (parentId) => `/parent/${parentId}/changeTheme/`;
const CHANGE_CHILD_THEME = (childId) => `/child/${childId}/changeTheme/`;
const UPDATE_PARENT = (parentId) => `/parent/${parentId}/`;
const UPDATE_CHILD = (parentId) => `/parent/${parentId}/update_child/`;

export default {
  MOTIVATIONAL_MESSAGE_PATH,
  SESSION_PATH,
  ABOUT_US,
  ABOUT_FAQS,
  ABOUT_COMMENT,
  FAQS_TOPICS,
  SETTINGS_TIMEZONES,
  SETTINGS_NOTIFICATION_SETUP,
  SETTINGS_GET_TIMEZONE_SETUP,
  SETTINGS_UPDATE_CONFIGURATION,
  GET_TIPS,
  GET_PARENT_BY_EMAIL,
  PARENT_ASSIGN_CHILDREN,
  INVITE_PARENT,
  CHANGE_PARENT_THEME,
  CHANGE_CHILD_THEME,
  UPDATE_PARENT,
  UPDATE_CHILD,
};

